export default __webpack_public_path__ + "static/media/closeIconWhite.09324a72.svg";